
<ng-container *ngIf="isLoaded">
  <div class="modal-close-btn" (click)="closeModal()">X</div>
  <div class="card mb-3">
    <div class="card-body">
      <div class="pt-4 pb-2">
        <h5 class="card-title text-center pb-0 fs-4">Добавяне на Сметка</h5>
        <p class="text-center small">Моля, въведете данните</p>
      </div>

      <form [formGroup]="Form" class="row g-3 needs-validation" (ngSubmit)="onSubmit()">
        <div class="col-12">
          <label for="title" class="form-label">Наименование</label>
          <input type="text" formControlName="title" class="form-control" id="title">
        </div>
        <div class="col-12">
          <label for="iban" class="form-label">ИБАН</label>
          <input type="text" formControlName="iban" class="form-control" id="iban">
        </div>
        <div class="col-12">
          <label for="bic" class="form-label">БИК</label>
          <input type="text" formControlName="bic" class="form-control" id="bic">
        </div>
        <div class="form-group col-md-8 payment-container">
          <label for="paymentMethod">Метод на плащане:</label>
          <div class="payment-wrapper">
            <select class="form-control" id="paymentMethod" [(ngModel)]="selectedStatus">
              <option *ngFor="let method of statuses" [value]="method.value">
                {{method.name}}
              </option>
            </select>
          </div>

        </div>
        <div class="col-12">
          <button class="btn btn-primary w-100" type="submit" [disabled]="!Form.valid">Добави</button>
        </div>
      </form>
    </div>
  </div>

</ng-container>
